module.exports = __webpack_public_path__ + "img/funnel-steroidi-2021.aaeac601.svg";